module.exports = __webpack_public_path__ + "static/media/25th_jan.5b4934c2.jpg";